import { canv } from "@/canv/global.js";

import { logException } from "@/canv/utils.js";
import { buildEvent } from "@/eventManager/events/buildEvent.js";
import { propertyBuildEvent } from "@/eventManager/events/propertyBuildEvent.js";
import { propertyEvent } from "@/eventManager/events/propertyEvent.js";
import { touchEvent } from "@/eventManager/events/touchEvent.js";

export class eventManager {
    constructor() { }

    // new events

    createBuildEvent(action, group) {
        var states = [];
        group.collectEntitiesStates(states);

        var event = new buildEvent();
        event.init(action, states);

        const twinEvent = new buildEvent();
        let twinAction = "create";
        if (action == "create") {
            twinAction = "delete";
        }
        twinEvent.init(twinAction, states);

        this.currentRecord.push(event);
        this.currentTwinRecord.unshift(twinEvent);
    }

    createPropertyEvent(UID, fixType, beforeState, afterState) {
        const event = new propertyEvent();
        event.init(UID, fixType, afterState);

        const twinEvent = new propertyEvent();
        twinEvent.init(UID, fixType, beforeState);

        this.currentRecord.push(event);
        this.currentTwinRecord.unshift(twinEvent);
    }

    createPropertyBuildEvent(UID, fixType, action, property) {
        var event = new propertyBuildEvent();
        event.init(UID, fixType, action, property);

        this.currentRecord.push(event);
        this.currentTwinRecord.unshift(event.getTwin());
    }

    createTouchEvent(UID) {
        var event = new touchEvent();
        event.init(UID);

        this.currentRecord.push(event);
        this.currentTwinRecord.unshift(event.getTwin());
    }

    //Функция для undo/redo ai-функционала
    /* createAndInsertAiTwinRecord(beforeStates, afterStates) {
        const twinRecord = [];

        for (const state of afterStates) {
            const twinEvent = new propertyEvent();
            twinEvent.init(state.UID, state.fixType, beforeStates[state.UID]);
            twinRecord.push(twinEvent);
        }

        twinRecord.reverse();
        this.uBuf.push(twinRecord);
    } */

    // -------------------------------------

    clear() {
        this.uBuf = [];
        this.rBuf = [];

        this.currentRecord = [];
        this.currentTwinRecord = [];

        this.needInitWidgets = [];
        this.rails = [];
    }

    openRecord() {
        this.currentRecord = [];
    }

    closeRecord() {
        if (this.currentRecord.length == 0) return;

        this.addRail(this.currentRecord, this.currentTwinRecord);

        this.uBuf.push(this.currentTwinRecord);

        canv.intercom.eventMessage(this.getRecordToSend(this.currentRecord));

        this.rBuf = [];

        if (this.uBuf.length >= this.uBufCapacity) {
            this.uBuf.splice(0, 1);
        }

        this.currentRecord = [];
        this.currentTwinRecord = [];
    }

    getRecordToSend(record) {
        const resultRecord = [];
        for (var i = 0; i < record.length; i++) {
            resultRecord.push(record[i].getEvent());
        }

        return resultRecord;
    }

    initWidgets() {
        for (let i = 0; i < this.needInitWidgets.length; i++) {
            this.needInitWidgets[i].initWidget();
        }
        this.needInitWidgets = [];
    }

    applyTransaction(record, addRail = false, buf = null) {
        const twinRecord = [];
        let allDone = true;
        for (let i = 0; i < record.length; i++) {
            if (!record[i].checkEvent()) {
                allDone = false;
                break;
            } else {
                const twinEvent = record[i].getTwin();
                record[i].execEvent();
                twinRecord.unshift(twinEvent);
            }
        }

        if (!allDone) {
            for (let i = 0; i < twinRecord.length; i++) {
                twinRecord[i].execEvent();
            }
            return false;
        }

        if (buf != null) {
            buf.push(twinRecord);
        }

        this.initWidgets();

        if (addRail) this.addRail(record, twinRecord);
        return true;
    }

    // Undo redo exec

    Undo() {
        try {
            if (this.uBuf.length == 0) {
                return;
            }

            var record = this.uBuf[this.uBuf.length - 1];
            var isDone = this.applyTransaction(record, true, this.rBuf);

            this.uBuf.splice(this.uBuf.length - 1, 1);

            if (isDone) {
                canv.intercom.eventMessage(this.getRecordToSend(record));
            }

            canv.redraw();
        } catch (e) {
            logException(e);
        }
    }

    Redo() {
        try {
            if (this.rBuf.length == 0) {
                return;
            }

            var record = this.rBuf[this.rBuf.length - 1];
            var isDone = this.applyTransaction(record, true, this.uBuf);

            this.rBuf.splice(this.rBuf.length - 1, 1);

            if (isDone) {
                canv.intercom.eventMessage(this.getRecordToSend(record));
            }

            canv.redraw();
        } catch (e) {
            logException(e);
        }
    }

    /// Got records tools /////////////////////

    getEventByType(type) {
        var event = null;
        if (type == "build") {
            event = new buildEvent();
        } else if (type == "property") {
            event = new propertyEvent();
        } else if (type == "propertyBuild") {
            event = new propertyBuildEvent();
        } else if (type == "touch") {
            event = new touchEvent();
        }

        return event;
    }

    processIncomingRecord(record) {
        this.revertRails();
        var eventsRecord = [];
        for (var i = 0; i < record.length; i++) {
            var event = this.getEventByType(record[i]["type"]);

            event.loadEvent(record[i]);
            eventsRecord.push(event);
        }

        this.applyTransaction(eventsRecord);
    }

    addRail(original, twin) {
        var data = {
            status: "applied",
            original: original,
            twin: twin,
        };

        this.rails.push(data);
    }

    getTwinRecord(record) {
        const twinRecord = [];
        for (let i = 0; i < record.length; i++) {
            const twinEvent = record[i].getTwin(); // важно взять его до apply
            twinRecord.unshift(twinEvent);
        }

        return twinRecord;
    }

    revertRails() {
        for (var i = this.rails.length - 1; i >= 0; i--) {
            var rail = this.rails[i];
            if (rail["status"] !== "applied") {
                break;
            }

            this.applyTransaction(rail["twin"]);

            rail["status"] = "reverted";
        }
    }

    proccessEventConfirm(data) {
        var status = data["isApplied"];

        if (this.rails.length === 0) return;

        if (status) {
            if (this.rails[0]["status"] === "reverted") {
                this.revertRails();
                this.applyTransaction(this.rails[0]["original"]);
                this.rails.splice(0, 1);
            } else {
                this.rails.splice(0, 1);
            }
        } else {
            if (this.rails[0]["status"] === "reverted") {
                this.rails.splice(0, 1);
            } else {
                this.revertRails();
                this.rails.splice(0, 1);
            }
        }
        canv.redraw();
    }

    uBuf = [];
    rBuf = [];
    currentRecord = [];
    currentTwinRecord = [];

    needInitWidgets = [];
    rails = [];

    uBufCapacity = 100;
}
